module.exports = __webpack_public_path__ + "static/img/wechat.52b240db.png";